import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import { getSwalTheme } from '../utils/swalTheme';
import './PostMedallionPage.css';

const PostMedallionPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const [listingType, setListingType] = useState('sell');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [formData, setFormData] = useState({
    title: '',
    description: '',
    price: '',
    quantity: '1',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleToggle = (type) => {
    setListingType(type);
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const data = {
      listing_type: listingType,
      title: formData.title,
      description: formData.description || null,
      price: formData.price ? parseFloat(formData.price) : null,
      quantity: formData.quantity ? parseInt(formData.quantity) : 1,
    };

    setLoading(true);

    try {
      await api.post('/medallion-posts', data);
      await Swal.fire({
        ...getSwalTheme(),
        icon: 'success',
        title: 'Medallion Listing Posted!',
        text: 'Your listing is now visible to others.'
      });
      navigate('/medallions');
    } catch (err) {
      Swal.fire({
        ...getSwalTheme(),
        icon: 'error',
        title: 'Post Failed',
        text: err.response?.data?.error || err.message || 'Failed to create listing'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="post-medallion-page">
      <div className="post-medallion-container">
        <h1>Medallion Listing</h1>
        <p className="subtitle">Buy or sell a taxi medallion</p>

        <div className="medallion-toggle">
          <button
            type="button"
            className={`medallion-toggle-btn ${listingType === 'sell' ? 'active' : ''}`}
            onClick={() => handleToggle('sell')}
          >
            Selling a Medallion
          </button>
          <button
            type="button"
            className={`medallion-toggle-btn ${listingType === 'buy' ? 'active' : ''}`}
            onClick={() => handleToggle('buy')}
          >
            Buying a Medallion
          </button>
        </div>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit} className="post-medallion-form">
          <div className="form-group">
            <label htmlFor="title">Title *</label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder={listingType === 'sell'
                ? 'e.g., Yellow Cab medallion for sale'
                : 'e.g., Looking to buy a Yellow Cab medallion'
              }
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="description">Description</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Add any additional details..."
              rows={3}
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="price">Price</label>
              <div className="rate-input-wrapper">
                <span className="rate-prefix">$</span>
                <input
                  type="number"
                  id="price"
                  name="price"
                  value={formData.price}
                  onChange={handleChange}
                  placeholder="e.g., 150000"
                  min="0"
                  step="0.01"
                  className="rate-input"
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="quantity">Quantity</label>
              <input
                type="number"
                id="quantity"
                name="quantity"
                value={formData.quantity}
                onChange={handleChange}
                min="1"
                max="999"
              />
            </div>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="cancel-btn"
              onClick={() => navigate('/medallions')}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="submit-btn"
              disabled={loading}
            >
              {loading ? 'Posting...' : 'Post Medallion Listing'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PostMedallionPage;
